import "../css/LandingPage.css";
import "../css/NavBar.css";
import { useEffect } from "react";
import Navbar from "../Components/NavBar";
import SectionNav from "../Components/SectionNav";
import HeroMobileSlider from "../Components/HeroMobileSlider";
import KWHeroSearch from "../Components/KWHeroSearch";
import FeaturedActiveListings from "../Components/FeaturedActiveListings";
import brickFooter from "../css/images/brick_footer.png";



import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";

import {
  RealEstateServices,
  TestimonialSlider,
  BlogPreview,
  MultiStepForm,
  KWListingsCTA,
} from "../Components";

const landingSections = [
  { id: "about", label: "Welcome" },
  { id: "services", label: "Buying/Selling" },
  { id: "market", label: "Home Value" },
  { id: "testimonials", label: "Testimonials" },
  { id: "blog", label: "Blog" },
  { id: "contact", label: "Let's Connect" },
  {
    type: "phone",
    label: "📞: (859) 803-3043",
    href: "tel:+18598033043"
  }
];


export default function LandingPage() {
  const propertiesHero = brickFooter;

  useEffect(() => {
    const hash = window.location.hash?.replace("#", "");
    if (!hash) return;

    // wait one tick so the DOM is painted
    requestAnimationFrame(() => {
      const el = document.getElementById(hash);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }, []);

  return (
    <div className="landing-container">
      <Navbar variant="landing" />

      <SectionNav sections={landingSections} offset={132} />

      {/* HERO */}
      <section className="hero">
        <div className="hero-media" aria-hidden="true">
          <video
            className="hero-video"
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
          >
            <source src="/imgs/hero_video.mp4" type="video/mp4" />
          </video>

          {/* Mobile still image fallback */}
          <div className="hero-image-wrapper">
            <HeroMobileSlider />
          </div>


          <div className="hero-overlay" />
        </div>

        <div className="hero-content">
          <div className="hero-branding">
            <img
              src="/imgs/kh_logo_transparent2.png"
              alt="Kentucky Home Living Logo"
              className="hero-logo"
            />
            <div className="hero-tagline">Your Kentucky REALTOR®</div>
          </div>
          <div className="hero-portfolio">
            <FeaturedActiveListings />
          </div>
        </div>
      </section >

      {/* ABOUT */}
      < section className="landing-section light" id="about" >
        <div className="about-grid">
          <div className="about-image">
            <img
              src="/imgs/brooke-headshot.jpg"
              alt="Brooke Roscoe - Northern Kentucky Real Estate"
            />
          </div>

          <div className="about-content">
            <h2
              style={{
                fontSize: "clamp(2rem, 6vw, 3.5rem)",
                lineHeight: 1.05,
              }}
            >
              Meet{" "}
              <span
                style={{
                  fontFamily: "var(--font-script)",
                  color: "var(--brand-accent)",
                  fontSize: "clamp(2rem, 6vw, 3.5rem)",
                  lineHeight: 1.05,
                }}
              >
                Brooke Roscoe
              </span>
            </h2>

            <p>
  As a lifetime resident of Kentucky, this has always been home. My roots run deep,
  and my passion for helping people feel confident in where they live guides
  everything I do.
</p>

<p>
  With over 20 years working in the home industry — from senior designer for one of
  the region’s largest home builders to owning my own interior design business —
  now while working in Real Estate I bring a unique perspective to buying and
  selling homes.
</p>

            <div className="about-actions">
              <a href="/about" className="btn primary">
                Learn More About Me
              </a>

              <div className="about-connect">
                <span className="about-connect-label">Connect with Brooke</span>

                <div className="about-socials">
                  <a
                    href="https://www.facebook.com/brookeroscoerealtor"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Facebook"
                  >
                    <FaFacebookF />
                  </a>

                  <a
                    href="https://www.instagram.com/brookeroscoerealtor/"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Instagram"
                  >
                    <FaInstagram />
                  </a>

                  <a
                    href="https://www.linkedin.com/in/brooke-roscoe/"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="LinkedIn"
                  >
                    <FaLinkedinIn />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section >

      {/* SERVICES */}
      < section className="landing-section dark" id="services" >
        <div className="landing-section-inner">
          <h2>How I Help You Navigate the Market</h2>
          <p className="landing-section-intro">
            Whether you’re buying your first home or selling your current one, you’ll have clear
            communication, honest advice, and local insight throughout the entire process.
          </p>
          <RealEstateServices />
        </div>
      </section >

      {/* PROPERTIES */}
      <section className="landing-section landing-properties" id="properties">
        <div className="landing-properties-hero" aria-hidden="true">
          <img src={propertiesHero} alt="" />
          <div className="landing-properties-overlay" />
        </div>

        <div className="landing-section-inner landing-properties-inner">
          <KWHeroSearch
            className="hero-search"
            secondaryLabel="Explore Neighborhoods"
            onSecondaryClick={() => {
              window.location.href = "/neighborhoods#search";
            }}
          />
        </div>
      </section>



      <section className="landing-section light" id="market">
        <KWListingsCTA />
      </section>

      {/* TESTIMONIALS */}
      <section className="landing-section dark" id="testimonials">
        <h2>Client Experiences</h2>
        <p className="landing-section-intro" id="intro-testimonials">
          Real stories from buyers and sellers I’ve had the privilege to work with.
        </p>
        <TestimonialSlider />
      </section>

      {/* Blog Preview */}
      <section className="landing-section light" id="blog">
        <h2>Check Out My Blog</h2>

        <BlogPreview />
      </section>

      {/* CONTACT */}
      <section className="landing-section dark" id="contact">
        <h2>I would love the opportunity to connect with you!</h2>
        <MultiStepForm />
      </section>

    </div >
  );
}
